export default __webpack_public_path__ + "static/media/Custom-HUD-Dock Icons (3 Icons).1ae5c2b0.jpg";